const asia_others_vet = "9d432f35-5e10-4fed-8fea-86c22166c0f8";
const asia_others_als_college = "9d432f37-f293-4574-9cf2-37d53fa95d0a";

const latam_eu_vet = "9d432f35-da19-4e6b-bf30-8deed37cec3f";
const latam_eu_elicos = "9d432f36-89d6-4f17-85ef-a1a89a7b5e3c";
const latam_eu_aged_care = "9d432f37-412e-4eba-8443-f1a5aa670375";
const latam_eu_adccd = "9d432f38-ae09-4c97-9a91-b621765f8f61";

// Unified 2026 - VET + Civil Construction (no Aged Care / Horticulture)
const unified_asia_others_vet = "2462d352-321f-11f1-85cf-bc2411d8a50e";
const unified_latam_eu_vet = "2462d364-321f-11f1-85cf-bc2411d8a50e";

const main_url = "https://apps.ihbrisbane.com";

export const productionPaymentCalculators = {
  main_url,
  // Asian market
  asia_others_vet,
  asia_others_als_college,
  // LATAM/Europe Market
  latam_eu_vet,
  latam_eu_elicos,
  latam_eu_aged_care,
  latam_eu_adccd,
  // Unified 2026
  unified_asia_others_vet,
  unified_latam_eu_vet,
};
